<template>
<!-- 邀请好友 -->
    <div  class="Booking">
        <TopNavigation  class="topNavigation"></TopNavigation>
        <div class="con">
            <div class="top">
                <!-- <div class="yaoqing"></div>
                <div class="zhedang"></div> -->

                <img class="yaoqing" src="../../assets/images/yaoqing/首图.png" alt="">
                <img class="zhedang" src="../../assets/images/yaoqing/遮挡.png" alt="">
                <!-- <div class="kait">
                    <div v-for="item in 5" :key="item">
                        用户******领取了7天会员
                    </div>
                    
                </div> -->
                <div class="kait">
                    <vue-seamless-scroll
                        :data="listData"
                        :class-option="classOption"
                        class="warp"
                        ref="seamlessScroll"
                    >
                        <ul class="ul-item">
                            <li class="li-item" v-for="(item, index) in listData" :key="index">
                                {{ item }}
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
            <div class="bottom">
                <div class="haoyou">
                    <img class="huiyuan" src="../../assets/images/yaoqing/会员.png" alt="">
                    <div class="person">
                        <div>
                            <div class="tian">{{userTotal}}<span>人</span></div>
                            <div>邀请总人数</div>
                        </div>
                        <div class="line"></div>
                        <div>
                            <div class="tian">{{yaoqingtian}}<span>天</span></div>
                            <div>奖励{{yaoqingTitle}}天数</div>
                        </div>
                    </div>

                    <div class="duocheng">
                        <div class="sm">
                            <div class="yuan">
                                <i class="el-icon-user-solid"></i>
                            </div>
                            <div class="xian"></div>
                            <div class="yuan">
                                <i class="el-icon-user-solid"></i>
                            </div>
                            <div class="xian"></div>
                            <div class="yuan">
                                <i class="el-icon-user-solid"></i>
                            </div>
                        </div>
                        <div class="xm">
                            <div class="xmyi">
                                <div>邀请好友</div>
                                <div class="xiao">分享邀请链接给好友</div>
                            </div>
                            <div class="xmyi">
                                <div>好友注册</div>
                                <div class="xiao xiaoer">好友通过链接完成注册</div>
                            </div>
                            <div class="xmyi">
                                <div>领取奖励</div>
                                <div class="xiao">登录账号查看邀请奖励</div>
                            </div>
                        </div>
                    </div>
                    <div  class="fuzhi">
                        <el-button @click="copyyaoqing">
                            复制邀请链接
                        </el-button>
                    </div>

                    <div class="rule">
                        <div class="gui">
                            活动规则
                        </div>
                        <div class="ze">
                            <div class="tit">
                                参与规则‌：
                            </div>
                            <ul>
                                <li>‌注册登录‌：确保你已在本平台完成注册并登录账号。</li>
                                <li>‌获取邀请链接‌：在活动页面或“我的账户”中找到“邀请好友”选项，获取你的专属邀请链接或邀请码。</li>
                                <li>‌分享邀请‌：通过社交媒体、电子邮件、短信等方式，将邀请链接或邀请码分享给你的亲朋好友。</li>
                                <li>‌好友注册‌：被邀请的好友需通过你的邀请链接完成注册，并成功成为平台新用户。</li>
                                <li>‌达到条件‌：当被邀请的好友完成注册，且这些好友在活动期间内有有效行为（如完成首次购买、连续登录等），你将获得免费会员时长奖励。</li>
                                
                            </ul>
                            <div class="tit">奖励说明‌：</div>
                            <ol>
                                <li>成功邀请满足条件的好友后，你将获得XX天的免费会员服务。</li>
                                <li>奖励将在活动结束后7个工作日内自动添加至你的账户，请留意账户变动通知。</li>
                            </ol>
                            <div class="tit">注意事项‌：</div>
                            <ol>
                                <li>每位用户仅限使用一次邀请链接，重复邀请不计入有效邀请数。</li>
                                <li>被邀请的好友必须为首次注册用户，且之前未通过其他渠道注册过本平台账号。</li>
                                <li>本活动最终解释权归平台所有，如有任何疑问，请联系客服咨询。</li>
                            </ol>
                        </div>
                    </div>
                </div>

                <div class="jilu">
                    <img class="huiyuan" src="../../assets/images/yaoqing/邀请好友.png" alt="">
                    <div class="biaoge">
                        <el-table
                            v-loading="tableLoading"
                            :data="userList"
                            style="width: 100%"
                            :header-cell-style="{ background: '#f9f9f9' }"
                            >
                            <el-table-column prop="nickname" label="被邀请人昵称">
                            </el-table-column>
                            <el-table-column prop="mobile" label="被邀请人手机号">
                            </el-table-column>
                            <el-table-column prop="create_time" label="邀请时间">
                            </el-table-column>
                            <el-table-column prop="reward_description" label="奖励类型">
                            </el-table-column>
                        </el-table>
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="userForm.page_no"
                            :page-sizes="[10, 20, 30, 40]"
                            :page-size="userForm.page_size"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="userTotal">
                        </el-pagination>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>
    
<script>
import TopNavigation from "../HP/TopNavigationB.vue";
import vueSeamlessScroll from 'vue-seamless-scroll'
import { buyVipLists,userInviteLists,config } from "@/api/api";
export default {
    components:{
        TopNavigation,
        vueSeamlessScroll,
    },
    data() {
        return {
            currentPage:1,
            listData:[],
            listDataA: [1, 2, 3, 4, 5, 6],
            classOption: {
                limitMoveNum: 1,
                direction: 2,
                hoverStop: false,
            },
            intervalId:null,
            buyList:[],
            buyForm:{
                page_no:1,
                page_size:10,
            },
            buyTotal:0,
            userList:[],
            userForm:{
                page_no:1,
                page_size:10,
            },
            userTotal:0,
            headers:{
                token: localStorage.getItem('token')
            },
            tableLoading:false,
            yaoqingtian:0,
            yaoqingTitle:'普通会员'
        }
    },
    methods: {
        copyyaoqing(){
            // if (this.$route.query.sn) {
            //     this.parameter.sn = this.$route.query.sn
            // }
            let userInfo = JSON.parse(localStorage.getItem('userInfo'))
            let url = window.location.origin +'?sn=' + userInfo.sn
            // let url = window.location.href +'?invite_code=' + userInfo.sn
            // invite_code
            if (navigator.clipboard && window.isSecureContext) {
                this.$message.success('复制成功')
                return navigator.clipboard.writeText(url)
            } else {
                const textarea = document.createElement('textarea');
                textarea.value = url
                document.body.appendChild(textarea);
                textarea.select();
                const successful = document.execCommand('copy');
                if(successful){
                this.$message.success('复制成功')
                textarea.remove()
                }else{
                this.$message.success('复制失败')
                textarea.remove()
                }
            }
        },
        handleSizeChange(val) {
            this.userForm.page_size=val
            this.getuserInviteLists()
        },
        handleCurrentChange(val) {
            this.userForm.page_no=val
            this.getuserInviteLists()
        },
        dingshi(){
            // for (let i = 0; i < this.buyList.length; i++) {
            //     console.log(1111,'a',this.buyList[i]);
            //     this.listData.push(this.buyList[i])
            // }
            // console.log(1111,'a',this.listData);
            // this.listData=[...this.buyList]
            this.listData = this.listData.concat(this.buyList);
        },
        // 邀请记录
        async getbuyVipLists(){
            try {
                const res = await buyVipLists(this.buyForm,this.headers)
                if(res.code==1){
                    this.buyList = res.data.lists
                    this.buyTotal = res.data.count

                    if(this.buyList.length>0){
                        this.dingshi()
                    }else{
                        clearInterval(this.intervalId)
                    }
                }
            } catch (error) {
                console.log(error,'错误');
            }
        },
        // 邀请列表
        async getuserInviteLists(){
            this.tableLoading=true
            try {
                const res = await userInviteLists(this.userForm,this.headers)
                if(res.code==1){
                    this.userList = res.data.lists
                    this.userTotal = res.data.count
                    this.tableLoading=false
                }
            } catch (error) {
                console.log(error,'错误');
            }
        },
        // getTian()
        async getTian(){
            try {
                const res = await config(this.headers)
                if(res.code==1){
                    this.yaoqingtian=res.data.invite_new_user_gift_vip_type ==0 ? 0 : res.data.invite_new_user_gift_vip_day
                    if(res.data.invite_new_user_gift_vip_type !=0){
                        this.yaoqingtian= res.data.invite_new_user_gift_vip_day
                        this.yaoqingTitle=res.data.invite_new_user_gift_vip_type ==1 ? '普通会员' : '盯舱宝会员'
                    }
                }
            } catch (error) {
                console.log(error,'错误');
            }
        }
    },
    mounted(){
        this.getbuyVipLists()
        this.getuserInviteLists()
        this.getTian()
        // /config/getSpecificConfig
        this.intervalId = setInterval(() =>{
            this.buyForm.page_no += 1
            this.getbuyVipLists()
        },5000)
    },
    onBeforeUnmount(){
        clearInterval(this.intervalId)
    }
}
</script>
    
<style style lang="scss" scoped>
.topNavigation{
    background: #fff;
}

.con{
    height: 100%;
    // background: pink;
    padding-bottom: 32px;
    background: linear-gradient( 90deg, #F84E42 0%, #F8423C 55%, #F95646 100%);
}

.top{
    position: relative;
    width: 100%;
    height: 930px;
    img{
        width: 100%;
        height: 600px;
    }
    .yaoqing{
        position: absolute;
        top: 0;
        left: 0;
    }

    .zhedang{
        position: absolute;
        bottom: 0;
        left: 0;
    }

    .kait{
        z-index: 10;

        position: absolute;
        bottom: 112px;
        left: 360px;

        display: flex;
        div{
            // width: 200px;
            // height: 48px;
            // background: rgba(0, 0, 0, 0.1);
            border-radius: 24px 24px 24px 24px;
            
            color: #fff;
            text-align: center;
            line-height: 48Px;

            margin-left: 32px;
        }
    }

    .heng{
        display: flex;
    }
}

.bottom{
    width: 1200px;
    margin: 0 auto;
    .haoyou{
        height: 1062px;
        background: #FFFFFF;
        border-radius: 24px 24px 24px 24px;
        position: relative;
        .huiyuan{
            width: 386px;
            height: 60px;
            position: absolute;
            left: 407px;
            top: -18px;
        }

        .person{
            padding-top: 102px;
            margin-left: 384px;

            display: flex;
            align-items: center;

            div{
                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 16px;
                color: #999999;
                text-align: center;
                font-style: normal;
                text-transform: none;
            }
            
            .tian{
                font-size: 40px;
                color: #333;
                span{
                    font-size: 14px;
                }
                margin-bottom: 4px;
            }

            .line{
                width: 1px;
                height: 48px;
                background: #FE4346;
                border-radius: 0px 0px 0px 0px;
                margin: 0 120px;
            }
        }

        .duocheng{
            margin-top: 68px;
            .sm{
                display: flex;
                justify-content: center;
                align-items: center;
                .yuan{
                    width: 100px;
                    height: 100px;
                    background: linear-gradient( 180deg, #F57751 0%, #FE3D0A 100%);
                    border-radius: 50%;
                    text-align: center;
                    line-height: 100px ;
                    i{
                        font-size: 48px;
                        color: #fff;
                    }
                }
                .xian{
                    border: 2px dashed #FE4346;
                    width: 290px;
                }
            }
            .xm{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-top: 32px;
                .xmyi{
                    text-align: center;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 500;
                    font-size: 20px;
                    color: #333333;
                    font-style: normal;
                    text-transform: none;
                    .xiao{
                        font-size: 16px;
                        color: #999999;
                        margin-top: 4px;
                    }
                }
                .xiaoer{
                    margin: 0 240px;
                }
            }
        }

        .fuzhi{
            text-align: center;
            margin-top: 76px;
            margin-bottom: 60px;
           .el-button{
                width: 400px;
                height: 60px;
                background: #FE3D0A;
                border-radius: 30px 30px 30px 30px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                font-style: normal;
                text-transform: none;
           }
        }
        .rule{
            width: 1136px;
            height: 412px;
            background: #F9F9F9;
            border-radius: 16px 16px 16px 16px;
            margin: auto;

            .gui{
                width: 169px;
                height: 48px;
                background: #FE3D0A;
                border-radius: 16px 0px 16px 0px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 20px;
                color: #FFFFFF;
                text-align: center;
                line-height: 48px;
                font-style: normal;
                text-transform: none;
            }

            .ze{
                margin: 32px;

                font-family: PingFang SC, PingFang SC;
                font-weight: 500;
                font-size: 14px;
                line-height: 20px;
                color: #333333;
                font-style: normal;
                text-transform: none;

                ul,ol{
                    margin: 0;
                    margin-bottom: 24px;
                }
            }
        }
    }

    .jilu{
        margin-top: 66px;
        background: #FFFFFF;
        border-radius: 24px 24px 24px 24px;
        position: relative;
        // z-index: 9;
        .huiyuan{
            width: 386px;
            height: 60px;
            position: absolute;
            left: 407px;
            top: -18px;
            z-index: 99;
        }
    }
}

.biaoge{
    padding: 74px 32px 0px 32px;
}


.el-pagination{
    text-align: right;
    margin-top: 80px;
    padding-right:32px;
    padding-bottom:24px;

}

.warp {
    width: 1200px;
    // height: 120px;
    margin: 0 auto;
    overflow: hidden;
    ul {
      list-style: none;
      padding: 0;
      margin: 0 auto;
      &.ul-item {
        display: flex;
        .li-item {
          width: 200px;
            height: 48px;
            background: rgba(0, 0, 0, 0.1);
            border-radius: 24px 24px 24px 24px;
            
            color: #fff;
            text-align: center;
            line-height: 48Px;

            margin-left: 32px;
        }
      }
    }
  }
</style>